"use client";

import { LegalDocument } from "@/components/marketing/LegalDocument";

export default function TermsPage() {
  return (
    <LegalDocument
      titleKey="legal.termsTitle"
      introKey="legal.termsIntro"
      contactKey="legal.privacyContact"
      sections={[
        { headingKey: "legal.termsS1Heading", bodyKey: "legal.termsS1Body" },
        { headingKey: "legal.termsS2Heading", bodyKey: "legal.termsS2Body" },
        { headingKey: "legal.termsS3Heading", bodyKey: "legal.termsS3Body" },
        { headingKey: "legal.termsS4Heading", bodyKey: "legal.termsS4Body" },
        { headingKey: "legal.termsS5Heading", bodyKey: "legal.termsS5Body" },
        { headingKey: "legal.termsS6Heading", bodyKey: "legal.termsS6Body" },
        { headingKey: "legal.termsS7Heading", bodyKey: "legal.termsS7Body" },
        { headingKey: "legal.termsS8Heading", bodyKey: "legal.termsS8Body" },
        { headingKey: "legal.termsS9Heading", bodyKey: "legal.termsS9Body" },
      ]}
    />
  );
}
